export const SiteBrand = ({ href = "https://www.diotech.it", testId = "site-brand" }) => (
  <a href={href} className="inline-flex items-center gap-3 shrink-0" data-testid={testId}>
    <img src="/diotech-logo-bianco.png" alt="Diotech" width="44" height="44" className="h-11 w-11 object-contain" />
    <span className="dt-brand-type text-[22px] text-[#f8f8f4] flex flex-col">
      DIOTECH
      <span className="font-['DM_Sans'] text-[8.5px] tracking-[.18em] text-[#aaacae] mt-1">IL TUO PARTNER INFORMATICO</span>
    </span>
  </a>
);
